const app = angular.module('msi.analytics', [
  require('@ordergroove/brandy/src/app/core/constants'),
  require('@ordergroove/brandy/src/app/core/config')
]);

app.service('analytics', require('./analytics.service'));

module.exports = app.name;
